


























































































































import { Component, Vue, Prop } from 'vue-property-decorator';
import AdditionalDetail from './AdditionDetail.vue';
import CallPhone from '@/pages/showDetail/CallPhone.vue';
import Tooltip from '@/components/common/index/Tooltip.vue';
import getUrlParam from '@/common/utils/getUrlParam';
import CONFIG from '@/common/config';
import FailTooltip from '@/pages/showDetail/FailTooltip.vue';
import fetch from '@/common/api/fetch';
@Component({
  components: {
    'additional-detail': AdditionalDetail,
    'call-phone': CallPhone,
    'tool-tip': Tooltip,
    'fail-tip': FailTooltip
  }
})
export default class CancelDetailModal extends Vue {
  @Prop({ default: false, type: Boolean })
  show!: boolean;
  @Prop() item!: any;
  @Prop() XMCounter!: boolean;
  @Prop() templateType!: string;
  @Prop() enableLevelTwo!: boolean;

  showConfirmThree: boolean = false;

  // 点击确定
  handleOk(): void {
    this.$emit('ok');
  }

  handleCancle(): void {
    this.$emit('hide');
  }
  gotoXMCounter(id: string) {
    if (!this.XMCounter) {
      return;
    }
    let env: string = process.env.VUE_APP_DEPLOY_ENV as string;
    window.location.href = `${(CONFIG.hybirdUrl as any)[env]}/bank/new/wallet/detail?id=${id}&token=${getUrlParam('token')}&instId=${getUrlParam(
      'instId'
    )}&aid=${getUrlParam('aid')}&uid=${getUrlParam('uid')}&v=${getUrlParam('v')}${getUrlParam('vn') ? `&vn=${getUrlParam('vn')}` : ''}`;
  }
  handleShowThreeModal(e: any, item: any) {
    this.$emit('refund');
  }
}
